import { Box, Typography, useTheme } from "@mui/material";
import { NoFilterSelectedIcon } from "../../assets/SvgIcons";

export default function NoData(): JSX.Element {
    const theme = useTheme()

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "60px 20px",
                minHeight: "300px",
            }}
        >
            <Box sx={{ marginBottom: "20px" }}>
                <NoFilterSelectedIcon />
            </Box>
            <Typography
                variant="h3"
                sx={{ marginBottom: "10px" }}
            >
                No Data to Display
            </Typography>
            <Typography
                variant="body_400"
                sx={{
                    color: theme.palette.grey[500],
                    textAlign: "center",
                    maxWidth: "500px"
                }}
            >
                Please select filters above and click &quot;Apply Filters&quot; to fetch and display the data.
            </Typography>
        </Box>
    )
}